<template>
  <div class="bg-white rounded-lg shadow p-3 mb-6">
    <div class="flex flex-col p-4 items-center" id="report-profitability">
      <div class="w-full flex flex-col items-center justify-center">
        <h1 class="text-2xl font-semibold mb-2">Análisis de Rentabilidad</h1>
        <Chart :options="chartOptions" />
      </div>
    </div>
  </div>
</template>

<script>
import numbers from "@/utils/numbers";

import { Chart } from "highcharts-vue";
export default {
  name: "ProfitabilityReports",
  components: {
    Chart,
  },
  props: {
    profitabilityMonths: {
      type: Array,
      default: () => [],
    },
    widthChart: {
      type: Number,
      default: 600,
    },
  },
  mounted() {
  },
  data() {
    return {
      chartOptions: {
        chart: {
          type: "column",
          height: 350,
          width: this.widthChart,
          reflow: true,
        },
        title: {
          text: null, // Oculta el título del gráfico
        },
        xAxis: {
          categories: this.monthNames(),
          title: {
            text: "Mes",
          },
        },
        yAxis: {
          title: {
            text: "Monto",
          },
        },
        tooltip: {
          shared: true,
          valuePrefix: "$",
        },
        plotOptions: {
          column: {
            grouping: true,
            shadow: false,
            borderWidth: 0,
          },
        },
        series: [
          {
            name: "Venta Total",
            data: this.getSalesData(),
            color: "#3b82f6", // azul
          },
          {
            name: "Costos",
            data: this.getCostsData(),
            color: "#f59e42", // naranja
          },
          {
            name: "Margen Bruto",
            data: this.getPartialSalesData(),
            color: "#22c55e", // verde
          },
          {
            name: "Gastos General",
            data: this.getExpensesData(),
            color: "#6366f1", // violeta
          },
          {
            name: "Impuestos",
            data: this.getTaxesData(),
            color: "#eab308", // amarillo
          },
          {
            name: "Utilidad",
            data: this.getTotalUtilityData(),
            color: "#ef4444", // rojo
          },
        ],
      },
    };
  },
  computed: {},
  methods: {
    moneyFormat(value) {
      const { currencySymbol } = this.$store.state.account;
      return numbers.moneyFormat(value, currencySymbol);
    },
    monthNames() {
      const months = [
        "Enero",
        "Febrero",
        "Marzo",
        "Abril",
        "Mayo",
        "Junio",
        "Julio",
        "Agosto",
        "Septiembre",
        "Octubre",
        "Noviembre",
        "Diciembre",
      ];
      return months.slice(0, this.profitabilityMonths.length);
    },
    getSalesData() {
      return this.profitabilityMonths.map((item) => item.totalSales);
    },
    getCostsData() {
      return this.profitabilityMonths.map((item) => item.totalCosts);
    },
    getPartialSalesData() {
      return this.profitabilityMonths.map((item) => item.partialSales);
    },
    getExpensesData() {
      return this.profitabilityMonths.map((item) => item.totalExpenses);
    },
    getTaxesData() {
      return this.profitabilityMonths.map((item) => item.totalTaxes);
    },
    getTotalUtilityData() {
      return this.profitabilityMonths.map((item) => item.totalUtility);
    },
  },
};
</script>

<style scoped>
.reports-index {
  margin-top: 40px;
}
</style>
